import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.10205 3.76844C2.10205 2.90519 2.10205 2.47356 2.28204 2.23563C2.43885 2.02835 2.67851 1.90008 2.93796 1.88459C3.23577 1.86681 3.59491 2.10623 4.31318 2.58508L13.6603 8.81652C14.2538 9.21219 14.5506 9.41002 14.654 9.65938C14.7444 9.87738 14.7444 10.1224 14.654 10.3404C14.5506 10.5897 14.2538 10.7876 13.6603 11.1832L4.31318 17.4147C3.59491 17.8935 3.23577 18.133 2.93796 18.1152C2.67851 18.0997 2.43885 17.9714 2.28204 17.7641C2.10205 17.5262 2.10205 17.0946 2.10205 16.2313V3.76844Z",
		stroke: "currentColor",
		strokeWidth: 2.28571,
		strokeLinecap: "round",
		fill: "currentColor",
		strokeLinejoin: "round"
	})
});
export default SvgPlay;
